import React from 'react';
import { useApp } from '../context/AppContext';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';
import './CookiePolicy.css';

const CookiePolicy = () => {
    const { t } = useApp();
    const cp = t.cookiePolicy || {};

    return (
        <>
            <Navbar />
            <div className="cookie-policy-page">
            <div className="cookie-policy-container">
                <div className="cookie-policy-header">
                    <h1>{cp.title || 'Politica de Cookie-uri'}</h1>
                    <p className="cookie-policy-date">{cp.lastUpdated || 'Ultima actualizare: 27 Ianuarie 2026'}</p>
                </div>

                <div className="cookie-policy-content">
                    {/* Section 1 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section1?.title || '1. Ce sunt cookie-urile?'}</h2>
                        <p>{cp.section1?.content}</p>
                    </section>

                    {/* Section 2 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section2?.title || '2. Cum folosim cookie-urile'}</h2>
                        <p>{cp.section2?.content}</p>
                        <ul>
                            <li><strong>{cp.section2?.items?.essential?.split(':')[0] || 'Cookie-uri esențiale'}:</strong> {cp.section2?.items?.essential?.split(':')[1]}</li>
                            <li><strong>{cp.section2?.items?.preferences?.split(':')[0] || 'Cookie-uri de preferințe'}:</strong> {cp.section2?.items?.preferences?.split(':')[1]}</li>
                            <li><strong>{cp.section2?.items?.analytics?.split(':')[0] || 'Cookie-uri de analiză'}:</strong> {cp.section2?.items?.analytics?.split(':')[1]}</li>
                            <li><strong>{cp.section2?.items?.marketing?.split(':')[0] || 'Cookie-uri de marketing'}:</strong> {cp.section2?.items?.marketing?.split(':')[1]}</li>
                        </ul>
                    </section>

                    {/* Section 3 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section3?.title || '3. Tipuri de cookie-uri pe care le folosim'}</h2>
                        
                        {/* Necessary Cookies */}
                        <div className="cookie-type">
                            <h3>{cp.section3?.necessary?.title}</h3>
                            <p>{cp.section3?.necessary?.description}</p>
                            <ul>
                                <li><code>cookieConsent</code> - {cp.section3?.necessary?.cookies?.consent}</li>
                                <li><code>sessionId</code> - {cp.section3?.necessary?.cookies?.session}</li>
                            </ul>
                        </div>

                        {/* Performance Cookies */}
                        <div className="cookie-type">
                            <h3>{cp.section3?.performance?.title}</h3>
                            <p>{cp.section3?.performance?.description}</p>
                            <ul>
                                <li><code>_ga</code> - {cp.section3?.performance?.cookies?.ga}</li>
                                <li><code>_gid</code> - {cp.section3?.performance?.cookies?.gid}</li>
                                <li><code>viewTracking</code> - {cp.section3?.performance?.cookies?.viewTracking}</li>
                            </ul>
                        </div>

                        {/* Functional Cookies */}
                        <div className="cookie-type">
                            <h3>{cp.section3?.functional?.title}</h3>
                            <p>{cp.section3?.functional?.description}</p>
                            <ul>
                                <li><code>user_language</code> - {cp.section3?.functional?.cookies?.language}</li>
                                <li><code>viewed_announcements</code> - {cp.section3?.functional?.cookies?.viewedAnnouncements}</li>
                            </ul>
                        </div>

                        {/* Marketing Cookies */}
                        <div className="cookie-type">
                            <h3>{cp.section3?.marketing?.title}</h3>
                            <p>{cp.section3?.marketing?.description}</p>
                            <ul>
                                <li><code>_fbp</code> - {cp.section3?.marketing?.cookies?.fbp}</li>
                                <li><code>ads_preference</code> - {cp.section3?.marketing?.cookies?.adsPreference}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Section 4 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section4?.title}</h2>
                        <p>{cp.section4?.content}</p>
                        <ul>
                            <li><strong>Google Analytics:</strong> {cp.section4?.items?.analytics}</li>
                            <li><strong>Social Media:</strong> {cp.section4?.items?.social}</li>
                        </ul>
                    </section>

                    {/* Section 5 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section5?.title}</h2>
                        <p>{cp.section5?.content1}</p>
                        <p>{cp.section5?.content2}</p>

                        <div className="browser-instructions">
                            <h3>{cp.section5?.browserTitle}</h3>
                            <ul>
                                <li><strong>Chrome:</strong> {cp.section5?.browsers?.chrome}</li>
                                <li><strong>Firefox:</strong> {cp.section5?.browsers?.firefox}</li>
                                <li><strong>Safari:</strong> {cp.section5?.browsers?.safari}</li>
                                <li><strong>Edge:</strong> {cp.section5?.browsers?.edge}</li>
                            </ul>
                        </div>
                    </section>

                    {/* Section 6 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section6?.title}</h2>
                        <p>{cp.section6?.content1}</p>
                        <p>{cp.section6?.content2}</p>
                    </section>

                    {/* Section 7 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section7?.title}</h2>
                        <p>{cp.section7?.content}</p>
                        <ul>
                            <li><strong>{cp.section7?.items?.session?.split(':')[0]}:</strong> {cp.section7?.items?.session?.split(':')[1]}</li>
                            <li><strong>{cp.section7?.items?.persistent?.split(':')[0]}:</strong> {cp.section7?.items?.persistent?.split(':')[1]}</li>
                        </ul>
                    </section>

                    {/* Section 8 */}
                    <section className="cookie-policy-section">
                        <h2>{cp.section8?.title}</h2>
                        <p>{cp.section8?.content1}</p>
                        <p>{cp.section8?.content2}</p>
                    </section>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
};

export default CookiePolicy;